import { environment } from '../../environments/environment';
export { environment } from '../../environments/environment';

export function GetReportingApiUrl(path: string, params?: object) {
    const reportingPrefix = environment.microserviceApiReporting;
    let url = environment.apiHost + reportingPrefix + path;
    if (params instanceof Object) {
        url += '?';

        Object.entries(params).forEach(([param, value]) => {
            url += `${encodeURIComponent(param)}=${encodeURIComponent(value)}&`;
        });
    }
    return url;
}
